import React from 'react';
import { Card, CardContent } from './ui/card';
import { cn } from "@/lib/utils";

interface ChartSummaryProps {
  summaryItems: string[];
  title?: string;
  className?: string;
}

const ChartSummary: React.FC<ChartSummaryProps> = ({ 
  summaryItems, 
  title = "Key Insights",
  className 
}) => {
  if (!summaryItems || summaryItems.length === 0) {
    return null;
  }

  return (
    <Card className={cn(className)}>
      <CardContent className="p-4">
        <h3 className="text-lg font-semibold mb-3">{title}</h3>
        <ul className="space-y-2">
          {summaryItems.map((item, index) => (
            <li key={index} className="flex items-start">
              <span className="inline-block w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
              <span className="text-sm text-gray-700 dark:text-gray-300">{item}</span>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};

export default ChartSummary;